// side effect: store configuration, when decisions are made
import {setDimmLevel, storeConfiguration} from '../slices/configurationSlice';
import {setProfileData} from '../lightProfile/lightProfileSlice';
import {setSolarData} from '../solar/solarSlice';
import {setOlivioData} from '../olivio/olivioSlice';
import {debounce} from '../util/debounce';
import {setKey, showVersionNotice} from '../slices/statusSlice';
import {selectFinalized} from '../selectors';
import {generateKey} from '../util/generateKey';
import {setIomoData} from '../iomo/iomoSlice';

const debouncedStoreConfiguration = debounce((store) => {
	if (store.getState().status.dataKey) {
		store.dispatch(storeConfiguration());
	}
}, 500);

export const dataStorageMiddleware = store => next => async action => {
    const result = next(action);

	// store
    if (
		action.type === 'status/duplicateConfiguration/fulfilled' ||
		action.type === 'spc/spcStoreConfiguration'
	) {
        // after decision(s), store the current state
		// when spc/spcStoreConfiguration, store only when default config is updated
		if (action.type !== 'spc/spcStoreConfiguration' || action.payload?.instance === 'default') {
			if (store.getState().status.dataKey) {
				store.dispatch(storeConfiguration());
			}
		}
    } else if (action.type === 'configuration/updatePersonalisation') {
		// Use the debounced function for this specific action type
		debouncedStoreConfiguration(store);
	} else if (action.type === 'configuration/saveCanvasImage') {
		//console.log('configuration/saveCanvasImage dispatch storeConfiguration', store.getState().configuration.data);
		//debouncedStoreConfiguration(store);
	}

	// load
	if (action.type === 'configuration/configurationLoading/fulfilled') {
		//check formatVersion
		//console.log('formatVersion', action.payload.data.formatVersion, store.getState().status.formatVersion);
		if (action.payload.data?.formatVersion && store.getState().status.formatVersion && action.payload.data?.formatVersion < store.getState().status.formatVersion) {
			console.log('Unsupported format version:', action.payload.data.formatVersion);
			store.dispatch(showVersionNotice({active: true, loaded: action.payload.data.formatVersion, current: store.getState().status.formatVersion}));
		}
		//const dataKey = store.getState().configuration.data.dataKey;
		//store.dispatch(setKey({key: dataKey}));
/*
		const uidFromRoute = store.getState().status.routeUid;
		const dataKey = store.getState().configuration.data.dataKey;
		const finalized = selectFinalized(store.getState());

		if (uidFromRoute === dataKey) {
			await store.dispatch(setKey({key: uidFromRoute}));
			console.log('using key from route: ', store.getState().status.dataKey);
		} else {
			await store.dispatch(setKey({key: generateKey()}));
			console.log('branching to new key:', store.getState().status.dataKey);
		}
*/

		if (action.payload.data.projects[0].project.lightProfileData) {
			await store.dispatch(setProfileData(action.payload.data.projects[0].project.lightProfileData));
		}
		if (action.payload.data.projects[0].project.dimmLevelData) {
			await store.dispatch(setDimmLevel(action.payload.data.projects[0].project.dimmLevelData));
		}
		if (action.payload.data.projects[0].project.solarData) {
			await store.dispatch(setSolarData(action.payload.data.projects[0].project.solarData));
		}
		if (action.payload.data.projects[0].project.olivioData) {
			await store.dispatch(setOlivioData(action.payload.data.projects[0].project.olivioData));
		}
		if (action.payload.data.projects[0].project.iomoData) {
			await store.dispatch(setIomoData(action.payload.data.projects[0].project.iomoData));
		}
	}
};
